import { LocalDateType } from '@app/models';
import { ACCEPTED_STATUS, Filter, FilterType, ProgressStatus, UserFilter } from '@app/pcs/models';
import { MY_PROGRESS_STATUSES } from '@app/pcs/reducer/advanced-search/search-form';
import { hasNoValue, isFalse } from '@util';
import * as R from 'ramda';

type OmitSelectedProperty = (userFilters: UserFilter[]) => UserFilter[];
export const omitSelectedProperty: OmitSelectedProperty = R.map(R.omit(['selected']));

export type IsDeadLineFilter = (filter: UserFilter) => boolean;
export const isDeadlineFilter: IsDeadLineFilter = R.pathEq(['filter', 'filterType'], FilterType.Deadline);

export type IsNotDeadLineFilter = (filter: UserFilter) => boolean;
export const isNotDeadlineFilter: IsNotDeadLineFilter = R.compose(R.not, isDeadlineFilter);

export type IsFilterVisible = (filter: UserFilter) => boolean;
export const isFilterVisible: IsFilterVisible = R.compose(isFalse, R.prop('hidden'));

export type GetVisibleFilters = (filters: UserFilter[]) => UserFilter[];
export const getVisibleFilters: GetVisibleFilters = R.filter<UserFilter>(isFilterVisible);

export type GetFilter = (filter: UserFilter) => Filter;
export const getFilter: GetFilter = R.prop('filter');

export type GetFilterName = (filter: UserFilter) => string;
export const getFilterName: GetFilterName = R.path(['filter', 'name']);

export type GetFilterId = (filter: UserFilter) => number;
export const getFilterId: GetFilterId = R.path(['filter', 'id']);

type GetTtpId = (filter: UserFilter) => number;
export const getTtpId: GetTtpId = R.path(['filter', 'dossierSearchModel', 'ttp', 'id']);

type GetValidTo = (filter: UserFilter) => LocalDateType;
export const getValidTo: GetValidTo = R.path(['filter', 'validTo']);

type GetMyProgressStatuses = (filter: UserFilter) => ProgressStatus[];
export const getMyProgressStatuses: GetMyProgressStatuses = R.path(['filter', 'dossierSearchModel', MY_PROGRESS_STATUSES]);

type GetProgressStatuses = (filter: UserFilter) => ProgressStatus[];
export const getProgressStatuses: GetProgressStatuses = R.path(['filter', 'dossierSearchModel', 'progressStatuses']);

type EmptyMyProgressStatuses = (filter: UserFilter) => boolean;
export const emptyMyProgressStatuses: EmptyMyProgressStatuses = R.compose(hasNoValue, getMyProgressStatuses);
type EmptyProgressStatuses = (filter: UserFilter) => boolean;
export const emptyProgressStatuses: EmptyProgressStatuses = R.compose(hasNoValue, getProgressStatuses);
type FiltersAll = (filter: UserFilter) => boolean;
export const filtersAll: FiltersAll = R.allPass([emptyMyProgressStatuses, emptyProgressStatuses]);

export type FiltersOthers = (filter: UserFilter) => boolean;
export const filtersOthers: FiltersOthers = R.allPass([R.compose(R.equals(1), R.length, getMyProgressStatuses),
  R.compose(R.includes(ACCEPTED_STATUS.id), R.prop('id'), R.head, getMyProgressStatuses)]);

export type FiltersMyUnresolved = (filter: UserFilter) => boolean;
export const filtersMyUnresolved: FiltersMyUnresolved = R.compose(hasNoValue, R.find(R.propEq('id', ACCEPTED_STATUS.id)), getMyProgressStatuses);

type GetDeadlineSuffix = (filter: UserFilter) => string;
export const getDeadlineSuffix: GetDeadlineSuffix = R.cond([
  [filtersAll, R.always('dashboard.filters.all')],
  [filtersOthers, R.always('dashboard.filters.others')],
  [filtersMyUnresolved, R.always('dashboard.filters.myUnresolved')],
  [R.T, R.always('')]
]);

type CanEditFilter = (filter: UserFilter) => boolean;
export const canEditFilter: CanEditFilter = R.propEq('editable', true);
